<a
  class="back-to-top foreground-jimmy"
  (click)="backToTopClicked()"
  *ngIf="isAvailable"
>
  Back to top
  <mat-icon> arrow_circle_up </mat-icon>
</a>
